import React from 'react';
import { graphql } from 'gatsby';
import { RecommendProducts } from '@sections/shared/GridView';
import { ABExperimentName, experiments } from '@utils/experiments/experiments';
import { useExperimentsTelemetry } from '@utils/experiments/useExperimentsTelemetry';
import RegistryV0 from '@sections/registry/RegistryV0/RegistryV0';
import RegistryV1 from '@sections/registry/RegistryV1/RegistryV1';

const page = 'registry';

interface RegistryBlogs {
  id: string;
  blogs: {
    link: string;
    title: string;
    excerpt: string;
    mediaLink: string;
  }[];
}

interface BlissRegistryData {
  recommendCatalogHomeSections: {
    sections: {
      paginatedCatalogEntities: {
        edges: RecommendProducts;
      };
    }[];
  };
}

interface RegistryPageData {
  bliss: BlissRegistryData;
  featureBlogs: RegistryBlogs;
}

export const query = graphql`
  {
    bliss {
      recommendCatalogHomeSections {
        sections(offset: 1, limit: 1) {
          paginatedCatalogEntities(first: 12) {
            edges {
              node {
                ... on Bliss_ProductCatalogEntityItemGroup {
                  catalogItemGroupData {
                    tileViewItem {
                      id
                      title
                      brand {
                        name
                        publicUrlPath
                      }
                      publicUrlPath
                      photos {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    featureBlogs {
      id
      blogs {
        link
        title
        excerpt
        mediaLink
      }
    }
  }
`;

const Registry = ({ data }: { data: RegistryPageData }) => {
  const RegistryConversionExperimentControl = experiments.RegistryConversionExperiment.Control.Component;
  const RegistryConversionExperimentVariant = experiments.RegistryConversionExperiment.Variant.Component;

  useExperimentsTelemetry({ name: ABExperimentName.RegistryConversionExperiment });

  return (
    <>
      <RegistryConversionExperimentControl>
        <RegistryV0 data={data} page={page} />
      </RegistryConversionExperimentControl>
      <RegistryConversionExperimentVariant>
        <RegistryV1 data={data} page={page} />
      </RegistryConversionExperimentVariant>
    </>
  );
};

export default Registry;
